import "./src/styles/bootstrap.min.css"
import "./src/styles/main.css"
import "./src/styles/responsive.css"
import "./src/styles/animate.min.css"
import wrapWithProvider from "./wrap-with-provider";
export const wrapRootElement = wrapWithProvider;